import styled from 'styled-components';
import IconDoing from '../IconDoing';

const IconDone = styled(IconDoing)`
  background-color: #999999;
`;

export default IconDone;
